import fr from './locales/en.json';
import i18n from './i18n';
import { TOptions } from 'i18next';

type DotNestedKeys<T> =
  T extends object
    ? { [K in Extract<keyof T, string>]:
      `${K}` | `${K}.${DotNestedKeys<T[K]>}` }[Extract<keyof T, string>]
    : never;

type AllKeys = DotNestedKeys<typeof fr>;

interface Tt {
  <K extends AllKeys>(key: K, options?: TOptions): string;
  <K extends AllKeys>(key: K, defaultValue: string, options?: TOptions): string;
}

export const tt: Tt = ((key: AllKeys, a?: unknown, b?: TOptions) =>
  typeof a === 'string'
    ? i18n.t(key as string, a, b)
    : i18n.t(key as string, a as TOptions)) as Tt;
